import { render, staticRenderFns } from "./schoolAdministratorAdd.vue?vue&type=template&id=8612746a&scoped=true&"
import script from "./schoolAdministratorAdd.vue?vue&type=script&lang=js&"
export * from "./schoolAdministratorAdd.vue?vue&type=script&lang=js&"
import style0 from "./schoolAdministratorAdd.vue?vue&type=style&index=0&id=8612746a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8612746a",
  null
  
)

export default component.exports